import React, { useContext } from 'react'
import { AccountsContext } from 'AccountsContext'
import { CANCELLATION_TEMPORARILY_DISABLED } from '../../../constants/app'
import CancellationBlockModal from '../../../newComponents/CancellationBlockModal'
import SupportBody from '../SupportBody'
import SupportHeader from '../SupportHeader'

const SupportWidget = ({ verticalName, setRefetchCases, isPWA = false }) => {
  const {
    isModalOpen,
    classesAddedToWidgetContainer,
    closeModal
  } = useContext(AccountsContext)
  const showGenericSupportModal =
    CANCELLATION_TEMPORARILY_DISABLED && isModalOpen

  return (
    <React.Fragment>
      <div
        className={
          isModalOpen && !showGenericSupportModal ?
            `${classesAddedToWidgetContainer} pushLeft` :
            'support-widget-container'
        }
      >
        <If condition={!showGenericSupportModal}>
          <SupportHeader
            verticalName={verticalName}
            setRefetchCases={setRefetchCases}
          />
        </If>
        <If condition={isModalOpen && !showGenericSupportModal}>
          <SupportBody verticalName={verticalName || 'air'} />
        </If>
      </div>
      <CancellationBlockModal
        isOpen={showGenericSupportModal}
        onClose={closeModal}
        isPWA={isPWA}
        variant="general"
      />
    </React.Fragment>
  )
}

export default SupportWidget
